import React from 'react'
import { AudienceRuleForm } from 'organisms/AudienceRuleForm'

export default function WebEmbedAudienceRule({ setAudienceRule, fields, getAudienceRulesState }) {
  function handleAudienceRulesChange(audienceRules) {
    setAudienceRule(audienceRules)
  }

  return (
    <AudienceRuleForm
      rules={getAudienceRulesState()}
      fields={fields}
      onChange={handleAudienceRulesChange}
      shouldShowAutocomplete
      shouldEnableFourComparison
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/WebEmbedSurveyPublish/WebEmbedAudienceRule.js